import { makeStyles } from "@material-ui/core/styles";

import {
  blueGrey,
  deepPurple,
  lightBlue,
  green,
  red,
  orange,
  indigo,
} from "@material-ui/core/colors";

export const useStyles = makeStyles((theme) => ({
  // ==========================================
  // SUMMARY CARDS
  // ==========================================

  paper: {
    width: "100%",
    height: "90px",
    padding: "8px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    "& h6": {
      fontSize: 12,
      fontWeight: 400,
      textTransform: "capitalize",
    },
  },

  nameDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flex: 1,
    minWidth: 0,
    paddingRight: "10px",

    "& h6": {
      fontSize: 12,
      fontWeight: 400,
      textTransform: "capitalize",
      lineHeight: 1.3,
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
    },
  },

  amount: {
    fontSize: 24,
    fontWeight: 500,
    fontFamily: "Montserrat, sans-serif",
    lineHeight: 1.1,
    marginTop: theme.spacing(0.5),
  },

  count: {
    fontSize: 13,
    fontWeight: 500,
    fontFamily: "Montserrat, sans-serif",
    lineHeight: 1.2,
    marginTop: theme.spacing(0.5),
  },

  activity: {
    color: blueGrey[500],
    backgroundColor: blueGrey[100],
  },

  updated: {
    color: lightBlue[500],
    backgroundColor: lightBlue[100],
  },

  created: {
    color: green[500],
    backgroundColor: green[100],
  },

  deleted: {
    color: red[500],
    backgroundColor: red[100],
  },

  // ==========================================
  // ACTIVITY LIST
  // ==========================================

  activityPaper: {
    width: "100%",
    overflow: "hidden",
  },

  activityRow: {
    minHeight: 76,
    padding: "10px 14px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    transition: "background-color 0.2s ease",

    "&:hover": {
      backgroundColor: "#fafafa",
    },
  },

  activityContent: {
    flex: 1,
    minWidth: 0,
  },

  actionText: {
    fontSize: 12,
    fontWeight: 600,
    fontFamily: "Montserrat, sans-serif",
    marginRight: 8,
  },

  moduleText: {
    fontSize: 12,
    fontWeight: 500,
    color: deepPurple[500],
    marginRight: 8,
  },

  referenceText: {
    fontSize: 12,
    fontWeight: 600,
    color: indigo[500],
  },

  description: {
    fontSize: 13,
    fontWeight: 400,
    color: "#555",
    marginTop: 3,
    marginBottom: 4,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  userText: {
    fontSize: 11,
    fontWeight: 600,
    marginRight: 8,
  },

  roleText: {
    fontSize: 10,
    color: "#777",
    backgroundColor: "#f1f1f1",
    borderRadius: 10,
    padding: "2px 7px",
    marginRight: 8,
  },

  dateText: {
    fontSize: 10,
    color: "#888",
  },

  // ==========================================
  // CHANGE DETAILS
  // ==========================================

  details: {
    padding: "12px 50px 16px 62px",
    backgroundColor: "#fafafa",
  },

  detailsTitle: {
    fontSize: 12,
    fontWeight: 600,
    marginBottom: 8,
    fontFamily: "Montserrat, sans-serif",
  },

  changeRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 8,
    padding: "6px 8px",
    marginBottom: 4,
    backgroundColor: "#fff",
    borderRadius: 4,
    border: "1px solid #eeeeee",
  },

  changeField: {
    fontSize: 11,
    fontWeight: 600,
    minWidth: 120,
  },

  oldValue: {
    fontSize: 11,
    color: red[500],
    textDecoration: "line-through",
    maxWidth: 300,
    wordBreak: "break-word",
  },

  arrow: {
    fontSize: 13,
    fontWeight: 600,
    color: "#888",
  },

  newValue: {
    fontSize: 11,
    color: green[600],
    fontWeight: 500,
    maxWidth: 300,
    wordBreak: "break-word",
  },

  metadata: {
    marginTop: 12,
    paddingTop: 10,
    borderTop: "1px solid #e5e5e5",
  },
}));
